import React from 'react';

const CarIcon = () => (
  <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40.5" r="40" fill="#F9FAFB" />
    <rect x="19.8379" y="28.4297" width="40.4096" height="30.5536" fill="#D9D6FE" />
    <path
      d="M19.8379 24.9802C19.8379 23.3472 21.1617 22.0234 22.7947 22.0234H57.2907C58.9237 22.0234 60.2475 23.3472 60.2475 24.9802V28.4298H19.8379V24.9802Z"
      fill="#344054"
    />
    <rect x="40.041" y="28.4297" width="20.2048" height="30.5536" fill="#9B8AFC" />
    <path
      d="M31.4927 43.7212L28.8281 47.2657H49.6189L44.1613 41.7344H35.4719C33.9069 41.7344 32.4331 42.4703 31.4927 43.7212Z"
      fill="#9DC1E4"
    />
    <path
      d="M24.9297 50.6751C24.9297 48.2312 26.9109 46.25 29.3548 46.25H50.2368C52.6807 46.25 54.6619 48.2312 54.6619 50.6751V52.6868C54.6619 53.9088 53.6713 54.8994 52.4493 54.8994H27.6954C26.1679 54.8994 24.9297 53.6611 24.9297 52.1337V50.6751Z"
      fill="white"
    />
    <circle cx="31.7904" cy="53.2748" r="2.29749" fill="#E4E7EC" stroke="#344054" strokeWidth="1.89205" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.0664 47.2657H49.6189L44.1613 41.7344H40.0664V47.2657Z"
      fill="#6E99C4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.9298 50.6463C24.9297 50.6559 24.9297 50.6655 24.9297 50.6751V52.2457C24.9297 52.2533 24.9297 52.2608 24.9298 52.2684V50.6463ZM40.0662 55.0113H52.344C53.566 55.0113 54.5565 54.0208 54.5565 52.7988V50.6751C54.5565 48.2312 52.5754 46.25 50.1315 46.25H40.0662V55.0113Z"
      fill="#E4E7EC"
    />
    <circle cx="47.8607" cy="53.2748" r="2.29749" fill="#E4E7EC" stroke="#344054" strokeWidth="1.89205" />
    <rect x="19.8379" y="56.5156" width="40.4096" height="2.464" fill="#667085" />
    <rect x="40.041" y="56.5156" width="20.2048" height="2.464" fill="#344054" />
    <path
      d="M30.6777 31.384C30.6777 30.8397 31.119 30.3984 31.6633 30.3984H40.0409V36.8048H31.6633C31.119 36.8048 30.6777 36.3636 30.6777 35.8192V31.384Z"
      fill="white"
    />
    <path
      d="M49.4023 31.384C49.4023 30.8397 48.9611 30.3984 48.4167 30.3984H40.0391V36.8048H48.4167C48.9611 36.8048 49.4023 36.3636 49.4023 35.8192V31.384Z"
      fill="#E4E7EC"
    />
    <rect x="32.6504" y="28.4297" width="1.9712" height="1.9712" fill="#344054" />
    <rect x="45.4648" y="28.4297" width="1.9712" height="1.9712" fill="#344054" />
    <path d="M58.8753 19.5L21.5195 61.5" stroke="#F97066" strokeWidth="1.719" strokeLinecap="round" />
  </svg>
);

export default CarIcon;
